import AccordionItem from './AccordionItem'

export { AccordionItem as default }
